// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3C9xz","tab":"ProcedureTabs_tab__3Z_to"};